
import { useState } from 'react';
import { 
  SparcConfig,
  CodeAnalysisResult,
  CodeModificationResult,
  CodeExecutionResult,
  CodeSearchResult,
  SparcLLMProvider
} from '@/services/agentic/sparcService';

/**
 * Hook for managing SPARC agent state
 */
export const useSparcAgentState = (defaultConfig?: SparcConfig) => {
  // Loading states
  const [loading, setLoading] = useState<boolean>(false);
  const [analyzing, setAnalyzing] = useState<boolean>(false);
  const [modifying, setModifying] = useState<boolean>(false);
  const [executing, setExecuting] = useState<boolean>(false);
  const [searching, setSearching] = useState<boolean>(false);
  const [initialized, setInitialized] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);
  
  // Configuration state
  const [availableProviders, setAvailableProviders] = useState<SparcLLMProvider[]>([]);
  const [config, setConfig] = useState<SparcConfig>(defaultConfig || {
    model: 'gpt-4o-mini',
    executionMode: 'semi',
    diffMode: 'file',
    processingMode: 'sequential',
    apiProvider: 'openai'
  });
  
  // Result states
  const [analysisResult, setAnalysisResult] = useState<CodeAnalysisResult | null>(null);
  const [modificationResult, setModificationResult] = useState<CodeModificationResult | null>(null);
  const [executionResult, setExecutionResult] = useState<CodeExecutionResult | null>(null);
  const [searchResult, setSearchResult] = useState<CodeSearchResult | null>(null);
  
  // Update configuration
  const updateConfig = (newConfig: Partial<SparcConfig>) => {
    setConfig(prevConfig => ({
      ...prevConfig,
      ...newConfig
    }));
  };

  return {
    // Loading states
    loading,
    setLoading,
    analyzing,
    setAnalyzing,
    modifying,
    setModifying,
    executing,
    setExecuting,
    searching,
    setSearching,
    initialized,
    setInitialized,
    error,
    setError,
    
    // Configuration
    config,
    setConfig,
    updateConfig,
    availableProviders,
    setAvailableProviders,
    
    // Results
    analysisResult,
    setAnalysisResult,
    modificationResult,
    setModificationResult,
    executionResult,
    setExecutionResult,
    searchResult,
    setSearchResult
  };
};
